import { RouteObject } from 'react-router';

import { NotFoundChildRoute } from 'src/app/NotFoundChildRoute';
import { VehicleInspectionsRoute } from 'src/features/fleet/inspection';

import { VehicleCredentialsRoute } from './credentials/VehicleCredentialsRoute';
import { VehicleManagementRoute } from './management/VehicleManagementRoute';

export const fleetRoutes: RouteObject[] = [
  {
    index: true,
    element: <VehicleManagementRoute />,
  },
  {
    path: 'inspections',
    element: <VehicleInspectionsRoute />,
  },
  {
    path: 'credentials',
    element: <VehicleCredentialsRoute />,
  },
  {
    path: '*',
    element: (
      <NotFoundChildRoute routePath="/fleet" linkText="Go back to fleet" />
    ),
  },
];
